import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class InvitationTokenService {

    private invitationToken: string | null = null;
    private pendingTeamId: number | null = null;

    setInvitationToken(invitationToken: string): void {
        this.invitationToken = invitationToken;
    }

    getInvitationToken(): string | null {
        return this.invitationToken;
    }

    setPendingTeamId(teamId: number): void {
        this.pendingTeamId = teamId;
    }

    getPendingTeamId(): number | null {
        return this.pendingTeamId;
    }

    clearPendingTeamId(): void {
        this.pendingTeamId = null;
    }
}
